export const expandAll = (data, setExpandedRows) => {
  let _expandedRows = [];

  data.forEach((p) => {
    _expandedRows.push(p);
  });
  setExpandedRows(_expandedRows);
};

export const collapseAll = (setExpandedRows) => {
  setExpandedRows(null);
};

export const getUserColors = (str) => {
  if (!str) return { light: '#f8fafc', dark: '#1e293b' };

  let hash1 = 0;
  let hash2 = 0;

  for (let i = 0; i < str.length; i++) {
    hash1 = str.charCodeAt(i) + ((hash1 << 5) - hash1);
    hash2 = str.charCodeAt(i) + ((hash2 << 7) - hash2);
  }

  const h = Math.abs(hash1) % 360;
  const s = 50 + (Math.abs(hash2) % 30);

  return {
    light: `hsl(${h}, ${s}%, 95%)`,
    dark: `hsl(${h}, ${s}%, 45%)`,
  };
};

export const countriesList = [
  { name: 'Austria', code: 'AT' },
  { name: 'Belgia', code: 'BE' },
  { name: 'Bośnia i Hercegowina', code: 'BA' },
  { name: 'Bułgaria', code: 'BG' },
  { name: 'Chorwacja', code: 'HR' },
  { name: 'Cypr', code: 'CY' },
  { name: 'Czechy', code: 'CZ' },
  { name: 'Dania', code: 'DK' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Finlandia', code: 'FI' },
  { name: 'Francja', code: 'FR' },
  { name: 'Grecja', code: 'GR' },
  { name: 'Hiszpania', code: 'ES' },
  { name: 'Holandia', code: 'NL' },
  { name: 'Irlandia', code: 'IE' },
  { name: 'Litwa', code: 'LT' },
  { name: 'Luksemburg', code: 'LU' },
  { name: 'Łotwa', code: 'LV' },
  { name: 'Malta', code: 'MT' },
  { name: 'Macedonia', code: 'MK' },
  { name: 'Niemcy', code: 'DE' },
  { name: 'Polska', code: 'PL' },
  { name: 'Portugalia', code: 'PT' },
  { name: 'Rumunia', code: 'RO' },
  { name: 'Serbia', code: 'RS' },
  { name: 'Słowacja', code: 'SK' },
  { name: 'Słowenia', code: 'SI' },
  { name: 'Szwajcaria', code: 'CH' },
  { name: 'Szwecja', code: 'SE' },
  { name: 'Węgry', code: 'HU' },
  { name: 'Wielka Brytania', code: 'GB' },
  { name: 'Włochy', code: 'IT' },
  { name: 'USA', code: 'US' },
  { name: 'Hongkong', code: 'HK' },
];

export const calculateGJ = (dateString) => {
  if (!dateString) return '-';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '-';

  const month = date.getMonth();
  let year = date.getFullYear();

  if (month < 2) {
    year = year - 1;
  }

  return year.toString().slice(-2);
};
